import {ProductNotifyAvailability} from 'modules/product-card/components/ProductNotifyAvailability';
import {ProductPriceBlock} from 'modules/product-card/components/ProductPriceBlock';
import {ProductRating} from 'modules/product-card/components/ProductRating';
import {ProductRatings} from 'modules/product-card/components/ProductRatings';
import style from './style.module.scss';
import {ProductFeatureList} from 'modules/product-card/components/ProductFeatureList';
import ProductGiftBanner from 'modules/product-card/pages/ProductPage/ProductGiftBanner';
import React, {FC} from 'react';
import ProductOnlineOnlyBanner from 'modules/product-card/pages/ProductPage/ProductOnlineOnlyBanner';
import {ProductSimilarBlock} from 'modules/product-card/pages/ProductPage/ProductSimilarBlock';
import {ISimilar} from 'modules/product-card/models/ProductResponse';
import ProductGrowingDiscountBanner from 'modules/product-card/pages/ProductPage/ProductGrowingDiscountBanner';
import {ILabel} from 'modules/products/types';

interface IProps {
    isShowNotifyAvailability: boolean;
    isOnlineOnly: boolean;
    similar?: ISimilar;
    giftBanner: {
        isShowBanner: boolean;
        title: string;
        url: string;
        imageUrl: string | null;
    };
    growingDiscountBanner?: ILabel;
}

const ProductBuyBlock: FC<IProps> = ({
    isShowNotifyAvailability,
    isOnlineOnly,
    giftBanner,
    similar,
    growingDiscountBanner,
}) => {
    const priceBlock = isShowNotifyAvailability ? <ProductNotifyAvailability /> : <ProductPriceBlock />;

    return (
        <div className={style.blockBuy}>
            {growingDiscountBanner && <ProductGrowingDiscountBanner {...growingDiscountBanner} />}

            {isOnlineOnly && <ProductOnlineOnlyBanner />}

            {giftBanner.isShowBanner && (
                <ProductGiftBanner title={giftBanner.title} url={giftBanner.url} imageUrl={giftBanner.imageUrl} />
            )}

            {'vintage' !== similar?.type && priceBlock}

            {similar && isShowNotifyAvailability && (
                <ProductSimilarBlock product={similar.product} type={similar.type} />
            )}

            <div className={style.infoBlock}>
                <div className={style.blockBuyRatingSW}>
                    <ProductRating />
                </div>
                <div className={style.blockBuyRatings}>
                    <ProductRatings />
                </div>
                <div className={style.blockBuyFeatures}>
                    <ProductFeatureList />
                </div>
            </div>
        </div>
    );
};

export default ProductBuyBlock;
